import { useTranslation } from 'react-i18next'

import { IQuestion } from 'cat-shared/utils'
import { AppChip, AppGroup } from 'client/ui-building-blocks'
import { useGetQuestionCategories } from 'client/api'

import styles from './question-meta-chips.module.scss'

type Props = {
  question: IQuestion
}

export const QuestionMetaChips = ({ question }: Props) => {
  const { i18n, t } = useTranslation()

  const { data: questionCategories } = useGetQuestionCategories({})

  return (
    <div className={styles.questionMetaChips}>
      <AppGroup gapSize="xxsmall">
        {question.category && questionCategories ? (
          <AppChip
            key={question.category}
            variant="success"
            text={
              questionCategories[i18n.language.toLowerCase()].find(
                c => c.key === question.category
              ).text
            }
          />
        ) : null}
        <AppChip
          key={question.type}
          variant="info"
          text={t('question.type', { returnObjects: true })[question.type]}
        />
      </AppGroup>
    </div>
  )
}
